import styles from './TopNav.module.scss'
import cx from 'classnames'
import DropDownFilter from '../DropDownFilter/DropDownFilter'
import { IconNavigationGroupProps, IconNavType, MonthProps } from '~types'
import { isNextButtonDisabled, isPrevButtonDisabled } from '../../../../utils'
import { useEventsStore } from 'store/useEventsStore'
import IconNavigationGroup from 'components/modules/IconNavigationGroup/IconNavigationGroup'

interface TopNavProps {
  setSelectedMonth: (month: MonthProps) => void
  handleNavigation: (key: string, shouldScrollTop?: boolean) => void
  isTablet: boolean
  iconNavigationGroup?: IconNavigationGroupProps
  isLoading: boolean
}

const TopNav = ({ setSelectedMonth, handleNavigation, isTablet, iconNavigationGroup, isLoading }: TopNavProps) => {
  const { selectedMonth, activeMonthList } = useEventsStore()
  const currentMonthKey = selectedMonth?.shortLabel.replace(/\s+/g, '-')
  const monthNavigationButtons: IconNavType[] = [
    {
      title: 'Previous month',
      iconName: 'chevron_left',
      onClick: () => handleNavigation('previous'),
      isDisabled: isPrevButtonDisabled(currentMonthKey, activeMonthList) || isLoading,
      isActive: false
    },
    {
      title: 'Next month',
      iconName: 'chevron_right',
      onClick: () => handleNavigation('next'),
      isDisabled: isNextButtonDisabled(currentMonthKey, activeMonthList) || isLoading,
      isActive: false
    }
  ]

  return (
    <div className={styles['navigation-filter-container']}>
      {!isTablet && (
        <>
          <button
            title='Today'
            onClick={() => handleNavigation('today')}
            className={styles['today-navigation']}
            disabled={isLoading}
          >
            Today
          </button>
          <div className={cx([styles['divider'], isLoading && styles['divider--is-dark']])} />
        </>
      )}

      <DropDownFilter
        selectedMonth={selectedMonth}
        activeMonthList={activeMonthList}
        handleMonthNavChange={setSelectedMonth}
        isLoading={isLoading}
      />

      {!isTablet && (
        <div className={styles['month-navigation-group']}>
          <IconNavigationGroup
            icons={monthNavigationButtons}
            isLoading={isLoading}
            alignment='left'
            parentLinkModule='calendar'
            theme={{
              hoverBackgroundColor: 'lightest'
            }}
            removePadding
          />
        </div>
      )}
      {iconNavigationGroup && (
        <IconNavigationGroup {...iconNavigationGroup} removePadding parentLinkModule='calendar' isLoading={isLoading} />
      )}
    </div>
  )
}

export default TopNav
